// extracted by mini-css-extract-plugin
export default {"button":"Er-z","reviewSort":"Fr-z"};